import { render } from "./LoginView.vue?vue&type=template&id=dc556964&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=dc556964&scoped=true&lang=css"

import exportComponent from "E:\\Web\\forgexsystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc556964"]])

export default __exports__